module.exports = __webpack_public_path__ + "static/img/product8.ea53d9d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product8.png
// module id = R9aT
// module chunks = 1